<!-- ami-reports.component.html -->
<div class="container-fluid pb-5">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1 class="page-header mb-0">View Reports</h1>
    <p class="section-subtitle mb-0">Select a report type to view or generate</p>
  </div>

  <!-- Quick Actions Section -->
  <section class="quick-actions-section mb-4">

      <div class="reports-grid-container">
        <div class="reports-grid-row">
          <a [routerLink]="['/ami-staff-performance']" class="report-card">
            <div class="card-icon-wrapper staff-performance">
              <span class="material-icons">assessment</span>
            </div>
            <div class="card-content">
              <h3 class="card-title">Staff Performance</h3>
              <p class="card-description">Track and analyze staff productivity metrics</p>
            </div>
            <span class="material-icons card-arrow">arrow_forward</span>
          </a>

          <a [routerLink]="['/studio-business-summary']" class="report-card">
            <div class="card-icon-wrapper business">
              <span class="material-icons">business_center</span>
            </div>
            <div class="card-content">
              <h3 class="card-title">Studio Business</h3>
              <p class="card-description">Review business performance and revenue</p>
            </div>
            <span class="material-icons card-arrow">arrow_forward</span>
          </a>

          <a [routerLink]="['/royalty-report']" class="report-card">
            <div class="card-icon-wrapper royalty">
              <span class="material-icons">account_balance</span>
            </div>
            <div class="card-content">
              <h3 class="card-title">Royalty Report</h3>
              <p class="card-description">Calculate and submit royalty payments</p>
            </div>
            <span class="material-icons card-arrow">arrow_forward</span>
          </a>
        </div>

        <div class="reports-grid-row">
          <a [routerLink]="['/miscellaneous-report']" class="report-card">
            <div class="card-icon-wrapper miscellaneous">
              <span class="material-icons">more_horiz</span>
            </div>
            <div class="card-content">
              <h3 class="card-title">Miscellaneous</h3>
              <p class="card-description">Additional reports and custom metrics</p>
            </div>
            <span class="material-icons card-arrow">arrow_forward</span>
          </a>

          <a [routerLink]="['/students-inventory']" class="report-card">
            <div class="card-icon-wrapper students">
              <span class="material-icons">groups</span>
            </div>
            <div class="card-content">
              <h3 class="card-title">Student Inventory</h3>
              <p class="card-description">Manage student enrollment and data</p>
            </div>
            <span class="material-icons card-arrow">arrow_forward</span>
          </a>
        </div>
      </div>
  </section>

  <!-- Submitted Reports Section -->
  <section class="submitted-reports-section">
    <div class="section-header">
      <h2 class="section-title">Report History</h2>
      <div class="filter-controls">
          <button class="filter-btn active" (click)="filterYear = null">
            All Years
          </button>
          <button *ngFor="let year of years.slice(0, 3)"
                  class="filter-btn"
                  [class.active]="filterYear === year"
                  (click)="filterYear = year">
            {{ year }}
          </button>
        </div>
      </div>

      <div class="years-accordion">
        <div *ngFor="let year of (filterYear ? [filterYear] : years)" class="year-group">
          <button class="year-header" (click)="toggleYear(year)" [class.expanded]="isYearExpanded(year)">
            <div class="year-header-content">
              <span class="material-icons expand-icon">
                {{ isYearExpanded(year) ? 'expand_less' : 'expand_more' }}
              </span>
              <h3 class="year-title">{{ year }}</h3>
              <span class="week-count-badge">{{ getWeeksForYear(year).length }} weeks</span>
            </div>
          </button>

          <div class="weeks-container" [class.expanded]="isYearExpanded(year)">
            <div class="weeks-grid">
              <div *ngFor="let week of getWeeksForYearReversed(year)" class="week-card">
                <div class="week-card-header">
                  <div class="week-info">
                    <h4 class="week-number">Week {{ week.key }}</h4>
                    <span class="week-date">{{ getWeekEndingDate(year, +week.key) }}</span>
                  </div>
                  <span *ngIf="isRejected(year, week)"
                        class="status-indicator rejected"
                        matTooltip="Report Rejected">
                    <span class="material-icons">warning</span>
                  </span>
                </div>

                <div class="week-card-body">
                  <div class="prepared-by-info">
                    <span class="info-label">Prepared by:</span>
                    <span class="info-value">
                      {{ getPreparedBy(year, week, 'staff_performance') ||
                         getPreparedBy(year, week, 'business') ||
                         getPreparedBy(year, week, 'royalty') ||
                         getPreparedBy(year, week, 'miscellaneous') ||
                         'Not submitted' }}
                    </span>
                  </div>
                </div>

                <div class="week-card-footer">
                  <div class="report-status-grid">
                    <button
                      class="status-btn"
                      [class.submitted]="isReportSubmitted(year, week, 'staff_performance')"
                      (click)="openReportDetails(year, week, 'staff_performance')"
                      matTooltip="Staff Performance">
                      <span class="material-icons">assessment</span>
                    </button>

                    <button
                      class="status-btn"
                      [class.submitted]="isReportSubmitted(year, week, 'business')"
                      (click)="openReportDetails(year, week, 'business')"
                      matTooltip="Studio Business">
                      <span class="material-icons">business_center</span>
                    </button>

                    <button
                      class="status-btn"
                      [class.submitted]="isReportSubmitted(year, week, 'royalty')"
                      (click)="openReportDetails(year, week, 'royalty')"
                      matTooltip="Royalty Report">
                      <span class="material-icons">account_balance</span>
                    </button>

                    <button
                      class="status-btn"
                      [class.submitted]="isReportSubmitted(year, week, 'miscellaneous')"
                      (click)="openReportDetails(year, week, 'miscellaneous')"
                      matTooltip="Miscellaneous">
                      <span class="material-icons">more_horiz</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </section>
</div>
